import React, {Component} from 'react';
import {connect} from 'react-redux';
import TableContainer from './TableContainer';
import {langEn, langPl} from './state/language'
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {setSquaresDataWithHash} from "./state/tableSquaresState";
import {setCirclesDataWithHash} from "./state/tableCirclesState";
import {activeTable} from "./state/activeTable";
import {setMataUrl} from "./state/mataUrl";
import AlertTooSmallScreen from "./AlertTooSmallScreen";
import Footer from "./Footer";
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hash: '',
            activeKey: 1
        };

        this.getHash = hash => {
            this.setState({hash: hash})
        };

        this.setActiveKey = () => {
            if (this.props.circlesState.hash === this.state.hash) {
                this.setState({activeKey: 2});
                this.props.activeTable('mata-circles')
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.hash !== prevState.hash) {
            this.setActiveKey();
        }
    }

    render() {
        return (
            <BrowserRouter>
                <div>
                    <AlertTooSmallScreen/>
                    <Switch>
                        <Route path="*/:hash?"
                               render={props => <TableContainer activeKey={this.state.activeKey}
                                                                getHash={this.getHash} {...props}/>}/>
                    </Switch>
                    <Footer />
                </div>
            </BrowserRouter>
        );
    }
}

export default connect(
    state => ({
        language: state.language,
        squaresState: state.squaresState,
        circlesState: state.circlesState,
    }),
    {langEn, langPl, setSquaresDataWithHash, setCirclesDataWithHash, activeTable, setMataUrl}
)(App);



// WEBPACK FOOTER //
// ./src/App.js